import React, { useState } from "react";
import { TimePicker } from "antd";
import "antd/dist/reset.css";

const SelectTime = ({
  disabled,
  register,
  value,
  name,
  label,
  onChangeFunction,
  required = false, // default to optional
}) => {
  const [time, setTime] = useState(value || null);
// console.log(value,time)
  const handleTimeChange = (time) => {
    setTime(time);
    if (onChangeFunction) {
      onChangeFunction(time);
    }
  };

  const handleOpenChange = (open) => {
    if (!open && time && onChangeFunction) {
      onChangeFunction(time);
    }
  };

  return (
    <TimePicker
      {...register(`${name}`, {
        required: required && !value ? `${label} is required!` : false,
      })}
      value={time || value}
      showNow={false}
      onChange={handleTimeChange}
      onOpenChange={handleOpenChange}
      format="HH:mm"
      placeholder="Pickup Time"
      className="w-full"
      style={{ minHeight: "40px" }}
      disabled={disabled}
    />
  );
};

export default SelectTime;
